export const GENERIC_REDIRECT_WHITELIST_PATHS = [
  '/sign-redo',
  '/manual-lender',
  '/my-claims',
  '/get-started/id-selfie-upload',
];
